module.exports = "<p>\r\n  calculo-porcentaje works!\r\n</p>\r\n"